import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale, faBuilding, faGavel, faFileContract } from '@fortawesome/free-solid-svg-icons';

function LegalPage() {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-indigo-600 to-purple-700 text-white">
                <div className="max-w-7xl mx-auto px-4 py-16">
                    <div className="text-center">
                        <div className="flex justify-center mb-6">
                            <FontAwesomeIcon icon={faBalanceScale} className="text-6xl text-indigo-200" />
                        </div>
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">
                            Aviso Legal
                        </h1>
                        <p className="text-xl text-indigo-100 max-w-3xl mx-auto">
                            Información legal sobre PetitPrime, sus servicios y las condiciones de uso de la plataforma.
                        </p>
                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
                            <div className="flex items-center space-x-2">
                                <FontAwesomeIcon icon={faGavel} className="text-indigo-200" />
                                <span>Información legal actualizada</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <FontAwesomeIcon icon={faFileContract} className="text-indigo-200" />
                                <span>Cumplimiento normativo</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 py-12">
                <div className="bg-white rounded-lg shadow-lg p-8">
                    {/* Company Information */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                            <FontAwesomeIcon icon={faBuilding} className="mr-3 text-indigo-600" />
                            1. Información de la Empresa
                        </h2>
                        <div className="bg-gray-50 rounded-lg p-6 mb-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-600">
                                <div>
                                    <p><strong>Razón Social:</strong> PetitPrime, S.L.</p>
                                    <p><strong>NIF/CIF:</strong> B-12345678</p>
                                    <p><strong>Domicilio Social:</strong> Barcelona, España</p>
                                </div>
                                <div>
                                    <p><strong>Email:</strong> legal@petitstores.com</p>
                                    <p><strong>Teléfono:</strong> +34 900 123 456</p>
                                    <p><strong>Registro Mercantil:</strong> Barcelona, Tomo 12345, Folio 123</p>
                                </div>
                            </div>
                        </div>
                        <p className="text-gray-600 leading-relaxed">
                            PetitPrime es una empresa española especializada en soluciones de fidelización digital para pymes,
                            registrada legalmente en España y sujeta a la legislación española y europea aplicable.
                        </p>
                    </section>

                    {/* Service Description */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">2. Descripción de Servicios</h2>
                        <p className="text-gray-600 leading-relaxed mb-4">
                            PetitPrime ofrece una plataforma integral de fidelización digital que incluye:
                        </p>
                        <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                            <li>Gestión de programas de lealtad y puntos</li>
                            <li>Herramientas de comunicación con clientes</li>
                            <li>Sistema de recompensas y descuentos</li>
                            <li>Analytics y reportes de fidelización</li>
                            <li>Integración con sistemas POS y CRM</li>
                            <li>Herramientas de gamificación y engagement</li>
                        </ul>
                        <p className="text-gray-600 leading-relaxed">
                            Los servicios se prestan a través de nuestra plataforma web y aplicaciones móviles,
                            sujetos a los términos y condiciones establecidos.
                        </p>
                    </section>

                    {/* Intellectual Property */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">3. Propiedad Intelectual</h2>
                        <p className="text-gray-600 leading-relaxed mb-4">
                            Todos los derechos de propiedad intelectual sobre la plataforma PetitPrime, incluyendo pero no limitado a:
                        </p>
                        <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                            <li>Software y código fuente</li>
                            <li>Diseños, interfaces y elementos gráficos</li>
                            <li>Marcas comerciales y logotipos</li>
                            <li>Contenido y documentación</li>
                            <li>Bases de datos y algoritmos</li>
                        </ul>
                        <p className="text-gray-600 leading-relaxed">
                            Son propiedad exclusiva de PetitPrime, S.L. o de sus licenciantes. Queda prohibida la reproducción,
                            distribución, modificación o uso comercial sin autorización expresa.
                        </p>
                    </section>

                    {/* User Obligations */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">4. Obligaciones del Usuario</h2>
                        <p className="text-gray-600 leading-relaxed mb-4">
                            Al utilizar nuestros servicios, el usuario se compromete a:
                        </p>
                        <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                            <li>Utilizar la plataforma de conformidad con la ley y los términos establecidos</li>
                            <li>No realizar actividades que puedan dañar, inutilizar o deteriorar la plataforma</li>
                            <li>No intentar acceder a áreas restringidas o sistemas informáticos</li>
                            <li>Respetar los derechos de propiedad intelectual</li>
                            <li>Proporcionar información veraz y actualizada</li>
                            <li>Mantener la confidencialidad de sus credenciales de acceso</li>
                        </ul>
                    </section>

                    {/* Limitation of Liability */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">5. Limitación de Responsabilidad</h2>
                        <p className="text-gray-600 leading-relaxed mb-4">
                            PetitPrime se compromete a prestar sus servicios con la máxima diligencia y profesionalidad,
                            sin embargo:
                        </p>
                        <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                            <li>No garantizamos la disponibilidad ininterrumpida del servicio</li>
                            <li>No nos hacemos responsables de daños indirectos o consecuenciales</li>
                            <li>La responsabilidad máxima está limitada al importe pagado por el servicio</li>
                            <li>No garantizamos resultados específicos de fidelización</li>
                        </ul>
                        <p className="text-gray-600 leading-relaxed">
                            Esta limitación no afecta a los derechos que no pueden ser excluidos por ley.
                        </p>
                    </section>

                    {/* Data Protection */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">6. Protección de Datos</h2>
                        <p className="text-gray-600 leading-relaxed mb-4">
                            El tratamiento de datos personales se rige por nuestra Política de Privacidad,
                            que cumple con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica
                            de Protección de Datos Personales (LOPDGDD).
                        </p>
                        <p className="text-gray-600 leading-relaxed">
                            Para cualquier consulta sobre el tratamiento de datos personales, puedes contactar
                            con nuestro Delegado de Protección de Datos en dpo@petitstores.com
                        </p>
                    </section>

                    {/* Applicable Law */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">7. Ley Aplicable y Jurisdicción</h2>
                        <p className="text-gray-600 leading-relaxed mb-4">
                            Las presentes condiciones se rigen por la legislación española. Para cualquier
                            controversia que pudiera surgir en relación con la interpretación, aplicación
                            o cumplimiento de estas condiciones:
                        </p>
                        <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                            <li>Se someten a la jurisdicción de los Juzgados y Tribunales de Barcelona</li>
                            <li>Se aplica la legislación española</li>
                            <li>Se respetan los derechos del consumidor según la normativa aplicable</li>
                        </ul>
                    </section>

                    {/* Modifications */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">8. Modificaciones</h2>
                        <p className="text-gray-600 leading-relaxed">
                            PetitPrime se reserva el derecho de modificar este aviso legal en cualquier momento.
                            Los cambios serán notificados a los usuarios a través de la plataforma o por correo electrónico.
                            El uso continuado de los servicios tras la modificación implica la aceptación de los nuevos términos.
                        </p>
                    </section>

                    {/* Contact Information */}
                    <section className="mb-12">
                        <h2 className="text-2xl font-bold text-gray-800 mb-6">9. Información de Contacto</h2>
                        <div className="bg-gray-50 rounded-lg p-6">
                            <p className="text-gray-600 mb-4">
                                Para cualquier consulta relacionada con este aviso legal:
                            </p>
                            <div className="space-y-2 text-gray-600">
                                <p><strong>Email:</strong> legal@petitstores.com</p>
                                <p><strong>Teléfono:</strong> +34 900 123 456</p>
                                <p><strong>Dirección:</strong> Barcelona, España</p>
                                <p><strong>Horario:</strong> Lunes a Viernes, 9:00 - 18:00 (CET)</p>
                            </div>
                        </div>
                    </section>

                    {/* CTA Section */}
                    <section className="text-center bg-gradient-to-r from-indigo-50 to-purple-50 rounded-lg p-8">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4">
                            ¿Necesitas más información legal?
                        </h3>
                        <p className="text-gray-600 mb-6">
                            Consulta nuestros términos y condiciones o política de privacidad para más detalles.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Link
                                to="/terminos"
                                className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-300"
                            >
                                Ver Términos y Condiciones
                            </Link>
                            <Link
                                to="/privacy"
                                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-300"
                            >
                                Ver Política de Privacidad
                            </Link>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default LegalPage; 